import { Badge, Text, Tooltip } from '@radix-ui/themes'
import { ExclamationTriangleIcon } from '@radix-ui/react-icons'
import { loggerMakerLabel } from '~/features/installations/constants'
import { profileAssembly, type InstallationProfileRow } from '../assembly'
import { MISSING_ASSEMBLY_PROFILE_DETAIL } from '../constants'

interface AssemblyProfileCellProps {
  profile: InstallationProfileRow
}

export const AssemblyProfileCell = ({ profile }: AssemblyProfileCellProps) => {
  const assembly = profileAssembly(profile)

  if (assembly.kind === 'missing') {
    return (
      <Tooltip content={MISSING_ASSEMBLY_PROFILE_DETAIL}>
        <Badge color="orange" variant="soft">
          <ExclamationTriangleIcon />
          No assembly profile
        </Badge>
      </Tooltip>
    )
  }

  if (assembly.kind === 'not-applicable') {
    return (
      <Badge color="yellow" variant="soft">
        Not needed ({loggerMakerLabel[assembly.loggerMaker]})
      </Badge>
    )
  }

  return (
    <Text size="2" className="font-mono">
      {assembly.assemblyProfile}
    </Text>
  )
}
